import React, { Component } from 'react'
import { Button, H1 } from "@blueprintjs/core"
import { AutoSizer, List } from 'react-virtualized'
import moment from 'moment'
import _ from 'lodash'
import DateRangePicker from 'react-bootstrap-daterangepicker'

import { RangeConfig } from '../../../config'
import storage from '../../../services/storage'
import axios from '../../../services/axios'
import { showMetrics } from '../../../config'
import Alert from '../../Shared/Alert'
import Post from '../Post/Post'

import 'bootstrap-daterangepicker/daterangepicker.css'
import './styles.css'

class MainContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      range: [
        moment(this.props.range[0]).startOf('day').toDate(),
        moment(this.props.range[1]).startOf('day').toDate()
      ],
      find: '',
      order: this.props.order,
      filter: this.props.filter,
      competitor: this.props.competitor,
      loading: false,
      postsTemp: [],
      posts: [],
      resize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    } 
    
    this.range = [
      moment(this.props.range[0]).startOf('day').toDate(),
      moment(this.props.range[1]).startOf('day').toDate()
    ]

    this.onFind = _.debounce(this.onFind.bind(this), 300)
    this.onResize = this.onResize.bind(this)
    this.onCompetitor = this.onCompetitor.bind(this)
    this.onFilter = this.onFilter.bind(this)
    this.onOrder = this.onOrder.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.onGetData = this.onGetData.bind(this)
    this.onChangeRange = this.onChangeRange.bind(this)
    this.onChangeCategory = this.onChangeCategory.bind(this)
  }
  
  componentWillMount(){
    window.addEventListener('resize', _.debounce(this.onResize, 500))
  }

  componentDidMount(){
    this.onSearch()
  }

  componentWillReceiveProps(props){
    if(this.props.filter != props.filter || this.props.order != props.order || this.props.competitor != props.competitor){
      const { postsTemp, find } = this.state
      const { order, filter, competitor } = props

      let posts = this.onFilter(filter, postsTemp, find)
      posts = this.onCompetitor(competitor, posts, filter)
      posts = this.onOrder(order, posts)

      this.setState({
        posts: posts
      })
    }
  }

  componentDidUnmount(){
    window.addEventListener('resize')
  }

  onFind(){
    const { postsTemp } = this.state
    const { value } = this.find
    const { order, filter, competitor } = this.props

    let posts = this.onFilter(filter, postsTemp, value)
    posts = this.onCompetitor(competitor, posts, filter)
    posts = this.onOrder(order, posts)

    this.setState({
      posts: posts,
      find: value
    })
  }

  onResize(event){
    this.setState({
      resize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    })
  }
  
  onCompetitor(competitor, posts, filter){
    posts = _.filter(posts, (post)=>{
      return (
        competitor == 'all' || 
        (post.is_brand && competitor == 'brand' ) ||
        (!post.is_brand && competitor != 'brand' && !!post.competitor && _.filter(post.competitor, (value)=>(value == competitor.id)).length > 0 && filter == 'all' ) ||
        (!post.is_brand && competitor != 'brand' && !!post.name && !!competitor.name && post.competitor.name.replace(/\s/g, "").toLowerCase() == competitor.name.replace(/\s/g, "").toLowerCase()) ||
        (!post.is_brand && competitor != 'brand' && !!post.competitor && !!post.competitor[filter] && !!competitor[filter] && post.competitor[filter].replace(/\s/g, "").toLowerCase() == competitor[filter].replace(/\s/g, "").toLowerCase())
      )
    })

    return posts
  }

  onFilter(filter, posts, content = ''){
    posts = _.filter(posts, (post)=>{
      const text = (post.caption || post.message || '').normalize("NFD").replace(/[\u0300-\u036f]/g, '').toLowerCase()
      let provider = post.provider

      switch (true) {
        case post.provider == 'ads-post-instagram':
          provider = 'instagram'
          break
        case post.provider == 'ads-post':
          provider = 'facebook'
          break
        default:
          provider = post.provider
          break
      }
      content = content.normalize("NFD").replace(/[\u0300-\u036f]/g, '').toLowerCase()

      return (filter == 'all' || provider == filter) && (content == '' ? true : text.includes(content))
    })

    return posts
  }

  onOrder(order, posts){
    switch (order) {
      case 'date':
        posts = _.orderBy(posts, ['post_published_date'], ['desc'])
        break
      case 'eng_score':
        posts = _.orderBy(posts, ['es_calculated'], ['desc'])
        break
      case 'es_competition':
        posts = _.orderBy(posts, (post)=>{
          return post.es_competition != undefined ?  post.es_competition : 0
        }, ['desc'])
        break
      case 'interactions':
        posts = _.orderBy(posts, (post)=>{
          let interactions = 0

          if(post.is_brand){
            interactions += post.wow + post.likes + post.anger + post.haha + post.sorry + post.love + post.anger
            interactions += post.shares
            interactions += post.comments
          }else{
            interactions += post.metrics.shares
            interactions += post.metrics.reactions
            interactions += post.metrics.comments
          }

          return interactions
        }, ['desc'])
        break
      case 'eng_score_organic':
        posts = _.orderBy(posts, ['es_calculated'], ['desc'])
        posts = _.filter(posts, (post)=>{
          return post.post_impressions_paid == 0
        })
        break
      case 'eng_score_paid':
        posts = _.orderBy(posts, ['es_calculated'], ['desc'])
        posts = _.filter(posts, (post)=>{
          return post.post_impressions_paid > 0 || post.provider == 'ads-post-instagram'
        })
        break
      case 'reach_organic':
        posts = _.orderBy(posts, ['post_impressions_organic'], ['desc'])
        posts = _.filter(posts, (post)=>{
          return !post.post_impressions_paid || post.post_impressions_paid == 0
        })
        break
      case 'reach_paid':
        posts = _.orderBy(posts, ['post_impressions_paid'], ['desc'])
        posts = _.filter(posts, (post)=>{
          return post.post_impressions_paid > 0 || post.provider == 'ads-post-instagram'
        })
        break
      case 'category':
        posts = _.orderBy(posts, ['es_calculated'], ['desc'])
        posts = _.filter(posts, (post)=>{
          return post.categoria_id == 1
        })
        break
    }

    return posts
  }

  onSearch(){
    this.onGetData()
  }

  onGetData(){
    const since = moment(this.range[0]).format('YYYY-MM-DD')
    const until = moment(this.range[1]).format('YYYY-MM-DD')
        
    storage.get('page')
    .then((page)=>{
      return Promise.all([axios.get(`brands/competitorPosts/${page}/${since}/${until}/all`), axios.get(`posts/brand/${page}/${since}/${until}/all`)])
    }).then((response)=>{
      const { order, filter, competitor } = this.props
      const { find } = this.state

      const competitors_posts = _.map(response[0].data.data, (post)=>{
        post.is_brand = false

        return post
      })

      const brand_posts = _.map(response[1].data.data, (post)=>{
        const brand = _.find(this.props.networks, {
          provider: 'facebook'
        })
        
        post.competitor = brand

        post.is_brand = true

        return post
      })

      let posts = _.concat(competitors_posts, brand_posts)

      posts = this.onFilter(filter, posts, find)
      posts = this.onCompetitor(competitor, posts, filter)
      posts = this.onOrder(order, posts)

      this.setState({
        postsTemp: _.concat(competitors_posts, brand_posts),
        loading: true,
        posts: posts
      })
    }).catch((error)=>{
      console.warn(error)
    })

  }

  onChangeRange({startDate, endDate}){
    const range = [startDate.toDate(), endDate.toDate()]

    this.dateStart.innerHTML = moment(range[0]).format('YYYY-MM-DD')
    this.dateEnd.innerHTML = moment(range[1]).format('YYYY-MM-DD')

    storage.set('range', range)
    
    this.range = range
  }

  onChangeCategory(id, category){
    const { order, filter } = this.props
    const { posts, postsTemp } = this.state
    let newPosts = _.map(posts, (post)=>{
      if(post.id == id){
        post.categoria_id = category
      }
      return {...post}
    })

    newPosts = this.onFilter(filter, newPosts)
    newPosts = this.onOrder(order, newPosts)

    const newPostsTemp = _.map(postsTemp, (post)=>{
      if(post.id == id){
        post.categoria_id = category
      }
      return {...post}
    })

    this.setState({
      posts: newPosts,
      postsTemp : newPostsTemp
    })
  }

  render () {
    const { userPermissions } = this.props
    const count = Math.floor((this.state.resize.width - 86)/368)
    const rows = _.chunk(this.state.posts, count)

    return(
      <div className="dashboardContainer">
        <Alert
          confirm 
          body='Your plan doesn’t have the required credentials to access this section. Please call you brand manager for further assistance.' 
          ref={(alert)=>(this.error = alert)} 
        />
        <div className="top-container">
          <div className="brands-added">
            <div className="grid">
              <div className="col-5_sm-12">
                <H1 className="brands-added__title">Content Analytics</H1>
              </div>
              <div className="col-7_sm-12">
                <div className="searchContainer" data-html2canvas-ignore>
                  <div className="searchSmart bp3-dark">
                    <input 
                      type="text" 
                      onPaste={this.onFind}
                      onKeyDown={this.onFind}
                      ref={(ref)=>(this.find = ref)}
                    />
                    <span className="searchFindIcon button-primary">
                      <i className="fas fa-search"></i>
                    </span>
                  </div>
                  <div className="dateSmart bp3-dark">
                    <span className="searchCalendarIcon button-primary"><i className="far fa-calendar-alt"></i></span>
                    <DateRangePicker
                      {...RangeConfig} 
                      startDate={this.state.range[0]} 
                      endDate={this.state.range[1]}
                      onApply={(event, picker)=>(this.onChangeRange(picker))}>
                      <div className="daterangepickerDates">
                        <span className="daterangepickerDate" ref={(ref)=>(this.dateStart = ref)}>
                          {moment(this.state.range[0]).format('YYYY-MM-DD')}
                        </span>
                        <span className="daterangepickerDate" ref={(ref)=>(this.dateEnd = ref)}>
                          {moment(this.state.range[1]).format('YYYY-MM-DD')}
                        </span>
                      </div>
                    </DateRangePicker>
                    <Button onClick={this.onSearch} minimal="true" className="button button-primary">Search</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="social-intelligence__container">
          <div className="dashboardContainerPosts">
            {this.state.loading && rows.length == 0 ? (
              <p className="dashboardNotData">No Data</p>
            ) : (
              <List
                width={this.state.resize.width - 86}
                height={this.state.resize.height - 160}
                rowHeight={showMetrics() ? 492 : 430}
                rowCount={rows.length}
                rowRenderer={({key, index, isScrolling, isVisible, style})=>{
                  const posts = rows[index]

                  return (
                    <div
                      className='postsContainerRow'
                      key={key} 
                      style={style}>
                      {posts.map((post)=>{
                        return (
                          <Post
                            onErrorPermissions={()=>(this.error.show())}
                            lock={!userPermissions['Categorize']} 
                            onChangeCategory={this.onChangeCategory}
                            key={post.id}
                            {...post}
                          />
                        )
                      })}
                      {_.range(count - posts.length).map(()=>{
                        return (
                          <div className="postsContainerRowDummy" />
                        )
                      })}
                    </div>
                )}}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default MainContainer



// WEBPACK FOOTER //
// ./src/components/ContentAnalytics/MainContainer/MainContainer.js